const gtm_analytics = {
  methods: {
    // ======== Google Tag Manager Helper Function Start ========
    pushEvent(path, title) {
      let dataLayer = window.dataLayer
      if (dataLayer !== undefined) {
        dataLayer.push({
          'event': 'virtualPageview',
          'pagePath': path,
          'pageTitle': title
        });
      }
    },
    pushPopUp(path, title) {
      let dataLayer = window.dataLayer
      if (dataLayer !== undefined) {
        dataLayer.push({
          'event': 'popupEvent',
          'pagePath': path,
          'pageTitle': title
        });
      }
    },
// ========= Google Tag Manager Helper Function End =========
  }
};
export default gtm_analytics



// WEBPACK FOOTER //
// ./src/common/mixin/gtm_analytics.js